import {type} from "@codeArt/utils/common";
import React from "react";

const font = {
  s1: {
    fontSize: "0.875rem",
    lineHeight: "1.75rem"
  },
  s1d5: {
    fontSize: "0.92rem",
    lineHeight: "1.6rem"
  },
  s2: {
    fontSize: "0.98rem",
    lineHeight: "1.96rem"
  },
  s3: {
    fontSize: "1.1rem",
    lineHeight: "2.2rem"
  }
};

export function getFontSize(name){
  return name ? font[name].fontSize : null;
}
